import types from "./types";

export function allHorariosVans() {
  return { type: types.ALL_HORARIOS_VANS };
}
export function updateHorarioVans(payload) {
    return { type: types.UPDATE_HORARIO_VANS , payload};
  }
  
  export function filterHorariosVans() {
    return { type: types.FILTER_HORARIO_VANS };
  }
  export function addHorariosVans() {
    return { type: types.ADD_HORARIO_VANS  };
  }
  export function resetHorarioVans() {
    return { type: types.RESET_HORARIO_VANS };
  }
  export function removeHorarioVans() { //Soft Remove
    return { type: types.REMOVE_HORARIO_VANS };
  }
  export function allServiciosVans() { //Soft Remove
    return { type: types.ALL_SERVICES_VANS };
  }
  